import React from 'react';
import { navigate } from 'gatsby';
import { LargeText } from '../styles';
import { StyledInfoContainer, StyledImageContainer, StyledList, StyledInfoLink } from './styles';
import { toHtmlSanitize } from '../../../utils/remark-html';

const InfoContainer = ({
  image,
  titleColor,
  titleFontWeight,
  titleFontSize,
  title,
  description,
  list,
  link,
  ctaTitle
}) => (
  <StyledInfoContainer>
    {image && (
      <StyledImageContainer>
        <img src={image} alt="" />
      </StyledImageContainer>
    )}
    <h3 style={{ color: titleColor, titleFontWeight, fontSize: titleFontSize }}>{title}</h3>
    <LargeText dangerouslySetInnerHTML={{ __html: toHtmlSanitize(description) }} />
    {list && (
      <StyledList>
        {list.map((e, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`item-${i}`}>{e}</li>
        ))}
      </StyledList>
    )}
    {link && ctaTitle && (
      <StyledInfoLink emphasis="secondary" onClick={() => navigate(link)}>
        {ctaTitle}
      </StyledInfoLink>
    )}
  </StyledInfoContainer>
);

export default InfoContainer;
